import {everyPropKey} from "@/utils/dataTransformation";

export const prepareList = (list, eachObjPropFn, eachObjFn) => {
  const camelCasedList = list.map(obj => everyPropKey(obj, eachObjPropFn))
  return (...args) => camelCasedList.map(camelCasedObj => eachObjFn(camelCasedObj, ...args))
}
